import YFormMap from './Map';

export { YFormMap };
export default YFormMap;
